<template>
  <div>
  
     <Modal
            :mask-closable="false"
            v-model="setRelayObj.setRelayModal"
            title="接力棒次设置"
            :footerHide="true"
            width="300"
            @on-cancel="setRelayModalcancel"
           
        >
        <Form  ref="formValiEditRelay" :model="formValiEditRelay" :rules="ruleValidateRelay" :label-width="90" >
          
          <FormItem label="接力人数：" class="cf"  prop="relaySporterNum">
              <Input class="width70PX"  :maxlength="2"  placeholder="" v-model="formValiEditRelay.relaySporterNum" ></Input>
              <Button type="info" :disabled="disableds"   @click="setRelaySubmit('formValiEditRelay')">保存</Button>
          </FormItem>
          
        </Form>
    </Modal>

  </div>
</template>
<script>
import {addRelaycrease,getRelaycrease} from '@/lib/api/index.js'
export default { 
  /*
    allProp判断如果是全能的选手就不需要名次字段 
    group判断是否为综合成绩
    childTitle传给查看运动员项目的标题
  */
  props: ['setRelayObj'],
  data () {
    return {
      formValiEditRelay:{
        relaySporterNum:''
      },
      ruleValidateRelay:{
        relaySporterNum:[
          {required: true, message: '只能为数字类型', trigger: 'blur',pattern:/^[0-9]+$/}
        ]
      },
      disableds:false,
    }
  },
  computed: {
   setRelayModal()
   {
     return this.setRelayObj.setRelayModal;
   }
  },
  watch: {
    setRelayModal()
    {
      let _this = this;
      let data =  {
          event:_this.setRelayObj.event,
          gameId:_this.setRelayObj.gameId
      }
      this.formValiEditRelay.relaySporterNum = '';
      if(this.setRelayObj.setRelayModal)
      {
         
          getRelaycrease(data).then(res => {
              if(res.data.code == 0){

                if(res.data.data.relaySporterNum)
                {
                  this.formValiEditRelay.relaySporterNum = res.data.data.relaySporterNum.toString();
                }
                
              }else if(res.data.code == -2){
                  this.$Message.error("获取失败");
              }else if(res.data.code==10)
              {
                  this.$Message.info("登录token过期请重新登录");
                  this.$store.dispatch('loginOut');
              }else{
                  this.$Message.error(res.data.msg);
              }
          },err =>{
              this.$Message.error("网络连接失败");
          });
      }
       
    }
  },
  components: {
  }
  ,
  methods: {
  
    setRelayModalcancel()
    {
        this.handleReset('formValiEditRelay');
    },
    setRelaySubmit(name)
    {
      this.$refs[name].validate((valid) => { 
          if (valid) {
              this.disableds = true;
              let _this = this;
              
              let data = {
                  event:_this.setRelayObj.event,
                  relaySporterNum:_this.formValiEditRelay.relaySporterNum,
                  gameId:_this.setRelayObj.gameId,
              }
              this.loadings();
              addRelaycrease(data).then( (res) => {
                  if(res.data.code==0)
                  {
                      this.$Message.info("设置成功");
                      this.setRelayModalcancel();
                      this.disableds = false;
                      this.$emit('setRelayModalShow');
                      
                      this.$Spin.hide();
                  }else if(res.data.code == -2){
                      this.$Message.error("获取失败");
                      this.$Spin.hide();
                  }else if(res.data.code==10)
                  {
                      this.$Message.info("登录token过期请重新登录");
                      this.$store.dispatch('loginOut');
                  }else{
                      this.$Message.error(res.data.msg);
                      this.$Spin.hide();
                  }
              
              }).catch((error) => {
              })
          }
      })
    }
  },
  created () {
    
  },
  mounted () {
    
  }
}
</script>
<style scoped>
.heightList{padding: 32px 0;}
</style>



// WEBPACK FOOTER //
// src/components/setRelay.vue